/** Registro automático de errores de pantalla → POST /api/client-errors (Admin → Errores). Sin datos sensibles. */
import { getCurrentLang } from '@/contexts/LanguageContext';

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
const _sent = new Set();
const CHUNK_RX = /Loading chunk|ChunkLoadError|Failed to fetch dynamically imported module|Importing a module script failed/i;

export const isChunkError = (err) => CHUNK_RX.test(String(err?.message || err?.name || err || ''));

export const reportClientError = (err, { kind = 'render', componentStack = '' } = {}) => {
  try {
    const message = String(err?.message || err || 'Error desconocido').slice(0, 2000);
    const key = `${kind}:${message.slice(0, 120)}`;
    if (_sent.has(key) || _sent.size >= 10) return;
    _sent.add(key);
    const standalone = Boolean(window.matchMedia?.('(display-mode: standalone)')?.matches || window.navigator?.standalone);
    const body = JSON.stringify({
      message, name: String(err?.name || '').slice(0, 120), stack: String(err?.stack || '').slice(0, 6000),
      component_stack: String(componentStack || '').slice(0, 3000), path: window.location?.pathname?.slice(0, 400) || '',
      screen: document.title?.slice(0, 200) || '', kind, user_agent: `${navigator.userAgent}${standalone ? ' standalone' : ''}`.slice(0, 500),
      viewport: `${window.innerWidth}x${window.innerHeight}`, language: getCurrentLang(), app_build: process.env.REACT_APP_BUILD || '',
      client_time: new Date().toISOString(),
    });
    fetch(`${BASE_URL}/client-errors`, { method: 'POST', body, keepalive: true, credentials: 'include',
      headers: { 'Content-Type': 'application/json' } }).catch(() => {});
  } catch { /* nunca romper la UI por un aviso */ }
};

/** Chunk JS desactualizado tras un despliegue: recarga sola UNA vez antes de mostrar la pantalla de error. */
export const recoverFromChunkError = (err) => {
  if (!isChunkError(err)) return false;
  const k = 'lineage_chunk_reload';
  if (sessionStorage.getItem(k)) return false;
  sessionStorage.setItem(k, String(Date.now()));
  window.location.reload();
  return true;
};

let installed = false;
export const installGlobalErrorCapture = () => {
  if (installed) return;
  installed = true;
  window.addEventListener('error', (ev) => { if (ev?.error) reportClientError(ev.error, { kind: 'window.error' }); });
  window.addEventListener('unhandledrejection', (ev) => {
    const r = ev?.reason;
    if (r?.status === 0 || r?.networkError) return; // sin red: ya lo anota /client-log
    reportClientError(r instanceof Error ? r : new Error(String(r?.message || r)), { kind: 'unhandledrejection' });
  });
};
